import Link from 'next/link';
import React from 'react';

interface Props {
  tilstandsrapportId: string;
  id: string;
  children: React.ReactNode;
  className?: string;
  chat?: any;
}

function resolveLink(tilstandsrapportId: string, id: string, chat?: any  ): string {
  if(chat) {
    return `/${tilstandsrapportId}/utbedringsplan/${id}?chatId=${chat._id}`;
  }
  return `/${tilstandsrapportId}/utbedringsplan/${id}`;
}

const ItemContainer = ({ tilstandsrapportId, id, children, className, chat }: Props): JSX.Element => {
    return (
      <Link href={resolveLink(tilstandsrapportId, id, chat)}>
        <a className={className && className}>{children}</a>
      </Link>
    );
};

export default ItemContainer;